const MetadataDataType = {
    STRING: 'String',
    INTEGER: 'Int32',
    FLOAT: 'Float32',
};

export default MetadataDataType;
